export default "__VITE_ASSET__BvNWEnam__"